<template>
  <div
    id="enable-2fa-modal"
    scroll="keep"
    class="modal-card"
  >
    <div class="is-expanded">
      <div class="modal-header">
        {{ $t('two_factors.backup_key') }}:
        <span class="back-up-key">
          {{ backUpKey }}
          <b-icon
            v-clipboard:copy="backUpKey"
            v-clipboard:success="onCopy"
            v-clipboard:error="onCanNotCopy"
            icon="content-copy"
            custom-class="mg-l-10px"
          />
        </span>
        <div class="alert-msg">
          {{ $t('two_factors.please_save_backup_key') }}
        </div>
      </div>
      <div class="is-expanded">
        <VueQRCode
          id="enable-qr-code-2fa-image"
          :value="url"
          class="show-on-desktop"
        />
        <VueQRCode
          id="enable-qr-code-2fa-image"
          :value="url"
          :options="{ width: 150 }"
          class="show-on-mobile"
        />
        <div class="enter-code-box">
          <b-field :label="$t('two_factors.enter_2fa_code')">
            <b-input
              v-model="code"
              :placeholder="$t('two_factors.enter_2fa_code')"
              @keyup.enter.native="submit"
            />
          </b-field>
          <b-button
            :loading="isLoading"
            class="submit-btn"
            @click="submit"
          >
            {{ $t('buttons.submit') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQRCode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'Enable2FAModal',
  components: {
    VueQRCode
  },
  props: {
    backUpKey: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  data: () => ({
    code: '',
    isLoading: false
  }),
  beforeDestroy () {
    this.$emit('close')
  },
  methods: {
    submit () {
      if (this.code) {
        this.isLoading = true
        this.$emit('submit', this.code)
        this.$emit('close')
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Please fill the code from Google Authentication.'
        })
      }
    },
    onCopy () {
      this.$buefy.toast.open({
        type: 'is-success',
        message: `Copied !`
      })
    },
    onCanNotCopy () {
      this.$buefy.toast.open({
        type: 'is-danger',
        message: `Can't copy the back up key to clipboard, please try again`
      })
    }
  }
}
</script>

<style lang="scss">
#enable-2fa-modal .modal-content {
  overflow: hidden;
}
#enable-qr-code-2fa-image {
  img {
    margin: 0 auto;
  }
}
</style>

<style lang="scss" scoped>
.modal-card {
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 40px;
}
.modal-header {
  margin-bottom: 70px;
  font-family: Roboto;
  font-size: 15px;
  color: #000000;
  text-align: center;
  .back-up-key {
    font-weight: bold;
    overflow-wrap: break-word;
  }
}
.alert-msg {
  color: #2193ff;
}
.enter-code-box {
  margin-top: 7%;
}
.submit-btn {
  width: 100%;
  margin: 0 auto;
  padding: 20px 9px;
  color: #fff;
  font-weight: bold;
  background-color: #2193ff;
  border-radius: 3px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.show-on-desktop {
  margin: 0 auto;
  display: block;
}
.show-on-mobile {
  margin: 0 auto;
  display: none;
}
.mg-l-10px {
  margin-left: 10px;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  #enable-2fa-modal {
    width: 90vw;
    min-width: 0;
    margin: 0 auto;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .modal-card {
    padding: 7%;
  }
  .modal-header {
    margin-bottom: 7%;
  }
  #enable-2fa-modal {
    margin-top: 7%;
  }
  .show-on-desktop {
    display: none;
  }
  .show-on-mobile {
    display: block;
  }
}

/* iPhone 5/SE */
@media only screen and (max-width: 320px) {
  #enable-2fa-modal {
    margin-top: calc(7% + 10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Enable2FAModal.vue